package com.starparty.app.astro0

public class SP_Colour {
    var r: Int
    var g: Int
    var b: Int
    var a: Int

    constructor(r: Int, g: Int, b: Int, a: Int) {
        this.r = r
        this.g = g
        this.b = b
        this.a = a
    }
}